import {
  // -- GET (list)
  // GET_FLOW_TASKS_SUCCESS,
  // GET_FLOW_TASKS_FAILURE,
  // -- UPDATE
  UPDATE_FLOW_TASK_SUCCESS,
  UPDATE_FLOW_TASK_FAILURE,
  // -- ASSIGN
  ASSIGN_FLOW_TASK_SUCCESS,
  ASSIGN_FLOW_TASK_FAILURE
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

// let cacheItems = null

export const flowTasks = (state = {}, action) => {
  switch (action.type) {
    // -- GET FLOW TASKS (list)
    // case GET_FLOW_TASKS_FAILURE: {
    //   Logger.trace(LoggerTypes.WARN, '[REDUCER] flowTasks.GET_FLOW_TASKS_FAILURE()', { state, action })
    //   return { ...state, error: action.data }
    // }
    // case GET_FLOW_TASKS_SUCCESS: {
    //   const items = action.data || []
    //   Logger.trace(LoggerTypes.REDUCER, '[REDUCER] flowTasks.GET_FLOW_TASKS_SUCCESS()', { state, action })

    //   return {
    //     ...state,
    //     items: items
    //   }
    // }

    // -- UPDATE A FLOW TASK
    case UPDATE_FLOW_TASK_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] flowTasks.UPDATE_FLOW_TASK_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_FLOW_TASK_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] flowTasks.UPDATE_FLOW_TASK_SUCCESS()', { state, action })

      return {
        ...state,
        ...action.data
      }
    }

    // -- ASSIGN A FLOW TASK TO THE CURRENT ONE
    case ASSIGN_FLOW_TASK_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] flowTasks.ASSIGN_FLOW_TASK_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case ASSIGN_FLOW_TASK_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] flowTasks.ASSIGN_FLOW_TASK_SUCCESS()', { state, action })

      return {
        ...state,
        ...action.data
      }
    }

    default:
      return state
  }
}
